module.exports = __webpack_public_path__ + "media/music/1a87a73db1ba0193283680e37b35754e.mp3";